<div>
  {{ params.value?.value | date: 'HH:mm' }}
</div>
<app-cell-error-icon [params]="params"></app-cell-error-icon>
